import type { IconSvgObject } from './types';

const Audit01Icon: IconSvgObject = [
  ["path", { d: "M11 22H5C3.89543 22 3 21.1046 3 20V4C3 2.89543 3.89543 2 5 2H17C18.1046 2 19 2.89543 19 4V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 7H14.5M7.5 11H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 22L18.9749 19.9749M18.9749 19.9749C19.6082 19.3415 20 18.4665 20 17.5C20 15.567 18.433 14 16.5 14C14.567 14 13 15.567 13 17.5C13 19.433 14.567 21 16.5 21C17.4665 21 18.3415 20.6082 18.9749 19.9749Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Audit01Icon;
